module.exports = __webpack_public_path__ + "img/resident.9827ac92.svg";